<eo-search-panel
  [formGroup]="formGroup"
  [menuActions]="menuActions"
  [viewModeVisible]="viewModeVisible"
  [actionMenuVisible]="actionMenuVisible"
  [instructionsVisible]="instructionsVisible"
  [instructionsMenuItem]="instructionsMenuItem"
  (viewModeChange)="onViewModeSelect($event)"
  [isCollapsed]="collapsed"
>
  <ng-container header>
    <ng-content select="[header]" />
  </ng-container>

  <ng-container actions>
    <p-button
      *ngIf="createNewVisible"
      size="small"
      label="Νέα Αίτηση"
      icon="pi pi-plus"
      severity="success"
      [disabled]="createNewDisabled"
      (onClick)="onCreateNewClick()"
    />

    <p-button
      *ngIf="exportExcelVisible"
      size="small"
      label="Export Excel"
      icon="pi pi-download"
      severity="success"
      [disabled]="exportExcelDisabled"
      (onClick)="onExportExcelClick()"
    />
    <ng-content select="[actions]" />
  </ng-container>

  <div class="flex flex-column container p-3">
    <eo-form
      #eoForm
      *ngIf="formReady"
      [config]="getFormConfig()"
      [submitButtonVisible]="false"
      [submitButtonLoading]="isSubmitLoading()"
      [submitButtonLabel]="submitBtnLabel"
      [customFormControls]="customFormControls"
      (formSubmit)="onSubmit($event)"
      (formChange)="onFormChange($event)"
    />
    <div
      class="p-fluid flex flex-column md:flex-wrap md:flex-row md:justify-content-end gap-2 w-full mt-3"
    >
      <p-button
        size="small"
        label="Καθαρισμός"
        severity="warning"
        icon="pi pi-replay"
        (onClick)="onClear()"
        [disabled]="isLoading()"
        *ngIf="getShowClearButton()"
      />

      <p-button
        size="small"
        label="Αναζήτηση"
        icon="pi pi-search"
        [disabled]="!eoForm?.form?.valid || isLoading()"
        [loading]="isLoading()"
        (onClick)="onSubmit()"
      />
    </div>
  </div>
</eo-search-panel>

<div
  *ngIf="isNoDataLabelVisible()"
  class="flex justify-content-center m-3 font-semibold"
>
  Δεν βρέθηκαν δεδομένα με τα συγκεκριμένα κριτήρια
</div>

<eo-table
  #eoTableResults
  *ngIf="isTableVisible()"
  [currentPage]="getPage()"
  [rows]="getPagesize()"
  [totalRecords]="getTotalCount()"
  [config]="tableConfig"
  [loading]="isLoading() || loading"
  [sortMode]="sortMode"
  [customSort]="sort"
  (onSort)="onSort($event)"
/>

<eo-paginator
  *ngIf="isPaginatorVisible()"
  [currentPage]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  (pageChange)="onPageChange($event)"
/>

<p-confirmDialog key="searchPageMessage" />
